import { render, staticRenderFns } from "./TabSelector.vue?vue&type=template&id=a7bfceb0&scoped=true"
import script from "./TabSelector.vue?vue&type=script&lang=js"
export * from "./TabSelector.vue?vue&type=script&lang=js"
import style0 from "./TabSelector.vue?vue&type=style&index=0&id=a7bfceb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7bfceb0",
  null
  
)

export default component.exports